export default "__VITE_ASSET__tS4BOyKB__"